import { render } from "./RelatedPublications.vue?vue&type=template&id=7b9f9312"
import script from "./RelatedPublications.vue?vue&type=script&lang=js"
export * from "./RelatedPublications.vue?vue&type=script&lang=js"

import "./RelatedPublications.vue?vue&type=style&index=0&id=7b9f9312&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__